import {useBranding} from "../../../context/BrandingContext";

/**
 * useThemeColors
 *
 * Returns the resolved color tokens from BrandingContext.theme.colors.
 * Falls back to an empty object if something is missing, but given your setup
 * there will always be at least baseTheme.
 */
export default function useThemeColors() {
    const { theme } = useBranding();
    return theme?.colors || {};
}